import { useCallback } from 'react'
import useTracking from './useTracking'
import { useAppContext } from '../contexts/AppContext'
import { PurchaseChannelConfig } from '../types'

const DEFAULT_PURCHASE_CHANNELS: PurchaseChannelConfig[] = [
  { key: 'amazon', available: true },
  { key: 'rakuten', available: true },
]

export default function useLandingPageState() {
  const {
    isPremiumUser = false,
    userPhotos = [],
    premiumDeepLinkUrl = '',
    api,
    purchaseChannels = DEFAULT_PURCHASE_CHANNELS,
  } = useAppContext()

  const {
    logClickedBuyOnAmazon,
    logClickedBuyOnRakuten,
    logClickedLearnMoreAboutPremium,
    logClickedPurchaseStepsButtonAmazon,
    logClickedPurchaseStepsButtonRakuten,
  } = useTracking({ api: api || null })

  const handleBuyOnAmazonClick = useCallback(() => {
    logClickedBuyOnAmazon()
  }, [logClickedBuyOnAmazon])

  const handleBuyOnRakutenClick = useCallback(() => {
    logClickedBuyOnRakuten()
  }, [logClickedBuyOnRakuten])

  const isAllSoldOut = purchaseChannels.every(channel => !channel.available)
  const isAmazonSaleActive = purchaseChannels.some(
    channel => channel.key === 'amazon' && channel.available && channel.saleActive,
  )

  return {
    handleBuyOnAmazonClick,
    handleBuyOnRakutenClick,
    isAllSoldOut,
    isAmazonSaleActive,
    isPremiumUser,
    isUsingFallback: userPhotos.length === 0,
    logClickedLearnMoreAboutPremium,
    logClickedPurchaseStepsButtonAmazon,
    logClickedPurchaseStepsButtonRakuten,
    premiumDeepLinkUrl,
    purchaseChannels,
    userPhotos,
  }
}
